import CustomTabs from "./CustomTabs";

const SampleGalleryTabs = () => {
  return (
    <CustomTabs></CustomTabs>
  );
}

export default SampleGalleryTabs;